import { render, staticRenderFns } from "./CoManagePaymentMethodsInCheckout.vue?vue&type=template&id=747102b4&"
import script from "./CoManagePaymentMethodsInCheckout.vue?vue&type=script&lang=ts&"
export * from "./CoManagePaymentMethodsInCheckout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports